import { IRemapper } from "../../../../../Global/IRemapper";
import PlayerStatsModel from "./PlayerStatsModel";

export default class PlayerStatsRemapper
  implements IRemapper<PlayerStatsModel>
{
  fromResponse(response: any): PlayerStatsModel {
    try {
      const model = new PlayerStatsModel();

      model.playerId = response.player_id;
      model.position = response.position;
      model.minutesPlayed = response.minutes_played;
      model.yellowCards = response.yellow_cards;
      model.redCards = response.red_cards;
      model.goals = response.goals;
      model.penaltyGoals = response.penalty_goals;
      model.penaltyCommitted = response.penalty_committed;
      model.penaltyWon = response.penalty_won;
      model.penaltyMissed = response.penalty_missed;
      model.penaltySaved = response.penalty_saved;
      model.penaltyReceived = response.penalty_received;
      model.ownGoals = response.own_goals;
      model.assists = response.assists;
      model.cleanSheets = response.clean_sheets;
      model.shots = response.shots;
      model.shotsOn = response.shots_on;
      model.shotsBlocked = response.shots_blocked;
      model.offsides = response.offsides;
      model.foulsCommitted = response.fouls_committed;
      model.foulsWon = response.fouls_won;
      model.tackles = response.tackles;
      model.tacklesBlocks = response.tackles_blocks;
      model.tacklesInterceptions = response.tackles_interceptions;
      model.concededGoals = response.conceded_goals;
      model.caughtBall = response.caught_ball;
      model.saves = response.saves;
      model.passes = response.passes;
      model.crosses = response.crosses;
      model.interceptions = response.interceptions;
      model.keyPasses = response.key_passes;
      model.passesAccuracy = response.passes_accuracy;
      model.duels = response.duels;
      model.duelsWon = response.duels_won;
      model.dribblesAttempts = response.dribbles_attempts;
      model.dribblesSuccess = response.dribbles_success;
      model.dribblesPast = response.dribbles_past;
      model.updatedAt = response.updated_at;

      return model;
    } catch (e) {
      console.warn("There was a problem remapping the player stats", e);
      throw e;
    }
  }
}
